<div style="font-family: sans-serif;">

  <!-- Title -->
  <div class="bg-[#faf8f5] py-10 sm:py-14 text-center border-b border-gray-200">
    <h1 class="text-2xl sm:text-3xl font-bold text-gray-900 tracking-wide" style="font-family: 'Roboto Slab', serif;">Our Partners</h1>
    <div class="flex items-center justify-center gap-2 mt-3">
      <div class="w-8 h-[2px] bg-[#600b0b]"></div>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.5"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>
      <div class="w-8 h-[2px] bg-[#600b0b]"></div>
    </div>
  </div>

  <!-- Partner Logos -->
  <div class="max-w-[1100px] mx-auto px-4 sm:px-6 py-12 sm:py-16">
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-6">
      <div *ngFor="let partner of partners"
        class="bg-white border border-gray-200 rounded-lg flex items-center justify-center p-8 sm:p-10 h-[160px] sm:h-[180px] hover:shadow-lg transition-shadow">
        <img [src]="partner.logo" [alt]="partner.name"
          class="max-h-[80px] max-w-full object-contain"
          onerror="this.style.display='none'; this.parentElement.innerHTML='<span class=\'text-lg font-bold text-gray-700\'>' + this.alt + '</span>'" />
      </div>
    </div>
  </div>
</div>
